import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";

export class Podcast2026SeriesEpisodes extends Component {
  private _loadMoreButton: HTMLButtonElement | null = null;
  private _hiddenCards: HTMLElement[] = [];
  private _loadBatchSize: number = 4;

  constructor(element: HTMLElement, context: PageContext) {
    super(element, context);
  }

  public async init(): Promise<void> {
    const root = this._element.closest(".podcast-recent-episodes");
    if (!root) {
      return;
    }

    const loadBatchSize = this._element.dataset.loadBatchSize;
    if (loadBatchSize) {
      this._loadBatchSize = Number.parseInt(loadBatchSize, 10) || this._loadBatchSize;
    }

    this._loadMoreButton =
      root.querySelector<HTMLButtonElement>("[data-action='load-more-series-episodes']") ||
      root.querySelector<HTMLButtonElement>(".button-nav.button-nav__view-more .button-nav__button");
    this._hiddenCards = Array.from(this._element.querySelectorAll<HTMLElement>("[data-series-episode-hidden='true']"));

    if (!this._loadMoreButton || this._hiddenCards.length === 0) {
      if (this._loadMoreButton) {
        this._loadMoreButton.classList.add("d-none");
      }
      return;
    }

    this._loadMoreButton.addEventListener("click", () => this.loadMore());
  }

  private loadMore(): void {
    if (this._hiddenCards.length === 0) {
      this.hideButton();
      return;
    }

    const cardsToShow = this._hiddenCards.splice(0, this._loadBatchSize);
    cardsToShow.forEach(card => {
      card.hidden = false;
      card.removeAttribute("data-series-episode-hidden");
      card.classList.remove("podcast-series-episode--hidden");
    });

    // For each card we just revealed, find associated .mobile-ad-full-width.d-none siblings and remove d-none
    cardsToShow.forEach(card => {
      let adDiv = card.nextElementSibling as HTMLElement | null;
      // Check up to 2 siblings in case of whitespace nodes in HTML
      for (let i = 0; i < 2 && adDiv; i++) {
        if (adDiv.classList && adDiv.classList.contains("mobile-ad-full-width") && adDiv.classList.contains("d-none")) {
          adDiv.classList.remove("d-none");
          break;
        }
        adDiv = adDiv.nextElementSibling as HTMLElement | null;
      }
    });

    if (this._hiddenCards.length === 0) {
      this.hideButton();
    }
  }

  private hideButton(): void {
    if (this._loadMoreButton) {
      this._loadMoreButton.classList.add("d-none");
    }
  }
}

ComponentFactory.registerComponent("Podcast2026SeriesEpisodes", Podcast2026SeriesEpisodes);
